
import TableList from '@/components/TableList/index.vue';
import { parseTime } from '@/filters/index';
import { moduleOptions } from './options.js';
export default {
  props: ['list', 'timeZoneList', 'filterList'],
  components: {
    TableList: TableList
  },
  data: function data() {
    return {
      tableConfig: {}
    };
  },

  computed: {
    columnConfig: function columnConfig() {
      var _this = this;

      var self = this;
      var column = [{
        slot: 'action-cell'
      }, {
        label: '广告主名称',
        prop: 'adv_name'
      }, {
        label: '时区',
        prop: 'timezone',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            var option = self.timeZoneList.filter(function (item) {
              return item.value === row.timezone;
            })[0];
            if (option) return option.label.split('(')[0];
            return '-';
          }
        }
      }, {
        label: '结算方式',
        prop: 'account_type'
      }, {
        label: '流量类型',
        prop: 'module',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            var moduleOption = moduleOptions.filter(function (item) {
              return item.value === row.module;
            })[0];
            if (moduleOption) return moduleOption.label;
            return '-';
          }
        }
      }, {
        label: '账期',
        prop: 'start_date',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            if (row.start_date === '-') return '-';
            return row.start_date + '-' + row.end_date;
          }
        }
      }, {
        label: 'Invoice Name',
        prop: 'invoice_name'
      }, {
        label: 'Name Of Business',
        prop: 'company_name'
      }, {
        label: 'Address',
        prop: 'address'
      }, {
        label: 'uuid',
        prop: 'uuid',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            if (row.demand_id && typeof row.demand_id === 'number' && row.demand_id > 0) {
              return row.uuid + '<p><a target="_blank" href="#/butler/demand-detail/' + row.demand_id + '">\u67E5\u770B\u9700\u6C42</a></p>';
            }
            return row.uuid;
          }
        }
      }, {
        label: 'rev',
        prop: 'revenue'
      }, {
        label: 'cost',
        prop: 'cost'
      }, {
        label: 'BD',
        prop: 'bd'
      }, {
        label: 'BD Team',
        prop: 'bd_team'
      }, {
        label: 'BD-AM',
        prop: 'bd_am'
      }, {
        label: 'BD-AM Team',
        prop: 'bd_am_team'
      }, {
        label: 'PM-ADV',
        prop: 'pm_adv'
      }, {
        label: 'PM-ADV Team',
        prop: 'pm_adv_team'
      }, {
        label: 'Update Time',
        prop: 'updated_time',
        params: {
          innerText: function innerText(_ref5) {
            var row = _ref5.row;

            if (row.updated_time && row.updated_time !== '-') {
              return parseTime(row.updated_time, '{y}-{m}-{d} {h}:{i}:{s}');
            }
            return '-';
          }
        }
      }, {
        label: '状态',
        prop: 'status',
        params: {}
      }];
      if (this.filterList) {
        return column.filter(function (item) {
          return _this.filterList.indexOf(item.prop) !== -1;
        });
      }
      return column;
    }
  },
  methods: {
    handlePush: function handlePush(item) {
      this.$emit('push', item);
    },
    handleRenewal: function handleRenewal(item) {
      this.$emit('renewal', item);
    }
  }
};